import makeStyles from "@mui/styles/makeStyles";
import { FontFamilySwitch } from "../../utils";
export const useStyles = makeStyles((theme) => ({
    dialog_root: {
        "& .MuiDialog-paper": {
            borderRadius: theme.palette.borderRadius,
            padding: "0px",
            width: "600px",
        },
    },
    dialog_component: {
        backgroundColor: theme.palette.primary.main,
        backgroundImage: `url("/images/successBGImage.svg")`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        height: "250px",
    },
    dialog_Header: {
        padding: "20px",
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
    },
    dialog_close_button: {
        padding: "0px"
    },
    dialog_body: {
        padding: "0px 54px",
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
    },
    message_text: {
        textAlign: "center",
        fontFamily: FontFamilySwitch().bold,
        fontSize:"1rem",
        color: theme.typography.color.white
    },
    okay_button: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        height: "40px",
        width: "150px",
        padding: "10px 16px",
        borderRadius: theme.palette.borderRadius,
        border: `1px solid ${theme.palette.primary.contrastText}`,
        backgroundColor: theme.palette.primary.contrastText,
    },
    okay_button_text: {
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().bold,
        color: theme.palette.primary.main,
    },
}));